import { normalizeRotationDegrees } from './entityImageCanvasPivot';

/** Zoom slider: log10 scale so the midpoint is 1× (0.1× ← 1× → 10×). */
export const ZOOM_SLIDER_MIN = 0.1;
export const ZOOM_SLIDER_MAX = 10;
export const ZOOM_SLIDER_LOG_MIN = -1;
export const ZOOM_SLIDER_LOG_MAX = 1;

/** Rotation slider: signed degrees with 0° at the midpoint (−180° ← 0° → +180°). */
export const ROTATION_SLIDER_MIN = -180;
export const ROTATION_SLIDER_MAX = 180;

export function zoomFactorToSlider(zoomFactor) {
  const numeric = Number(zoomFactor);
  const zoom = Number.isFinite(numeric) && numeric > 0 ? numeric : 1;
  const clamped = Math.min(ZOOM_SLIDER_MAX, Math.max(ZOOM_SLIDER_MIN, zoom));
  return Math.log10(clamped);
}

export function sliderToZoomFactor(slider) {
  const numeric = Number(slider);
  if (!Number.isFinite(numeric)) {
    return 1;
  }
  const zoom = 10 ** numeric;
  return Math.min(ZOOM_SLIDER_MAX, Math.max(ZOOM_SLIDER_MIN, zoom));
}

/**
 * Map cropper / persisted degrees onto the signed slider.
 * Values already in [-180, 180] are kept so −180° does not snap to +180°.
 */
export function rotationToSlider(degrees) {
  const numeric = Number(degrees);
  if (!Number.isFinite(numeric)) {
    return 0;
  }
  if (numeric >= ROTATION_SLIDER_MIN && numeric <= ROTATION_SLIDER_MAX) {
    return numeric;
  }
  const normalized = normalizeRotationDegrees(numeric);
  return normalized > 180 ? normalized - 360 : normalized;
}
